import { disableFragmentWarnings, useApolloClient } from '@apollo/client';
import DataProviderClient from "./react/DataProvider.client.js";
import DataProviderServer from "./react/DataProvider.server.js";
import { DataProvider } from "./react/index.js";
import * as shapes from "./shapes/index.js";
import QueryContext from "./react/QueryContext.js";
import { QueryProvider } from "./react/QueryProvider.js";
import { hoist } from "./react/dataModel/hoist.js";
export * from "./react/dataModel/proptypes/index.js";
export * from "./react/dataModel/useDataModel.js";
export * from "./react/dataModel/useLazyDataModel.js";
export * from "./react/dataModel/extend.js";
export * from "./react/dataModel/useQueryAttributes.js";
export * from "./react/dataModel/cache-util.js";
export * from "./hoc/withQueryProvider.js";
disableFragmentWarnings();
export { DataProviderClient, DataProviderServer, DataProvider, shapes, QueryProvider, QueryContext, hoist, useApolloClient };
//# sourceMappingURL=index.js.map